import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-cancelling-uploads-modal',
  templateUrl: './cancelling-uploads-modal.component.html',
  styleUrls: ['./cancelling-uploads-modal.component.scss'],
  standalone: false
})
export class CancellingUploadsModalComponent implements OnInit {

  constructor(private modalController: ModalController) {
  }

  ngOnInit() {
  }

  close() {
    this.modalController.dismiss();
  }

  submit() {
    this.modalController.dismiss(true);
  }
}
